<template>
  <div>
    <h4>如果您新的功能需求，请联系客服，描述功能要求</h4>

    <el-button v-if="false" @click="startThread">发请求拿数据</el-button>
    <span v-if="false" >状态：{{status}}</span>
  </div>
</template>

//https://blog.csdn.net/weixin_43216105/article/details/89555480

<script>
  import $api from "../api/axios";
  import storage from "../api/storage"
  import {hideLoading, showLoading} from "../api/loading";

    export default {
        name: "Custom",
      data(){
          return{
            status: 'running',
            timer:'',
            loading:'',
          }
      },
      computed: {
        // 计算属性
        statusData() { return this.status }
      },
      watch: {
        statusData: function (newval) {
          // 当返回的新值为创建中的时候,保持3秒轮询
          if (newval == 'running1') {
            var timer = setInterval(() => {
              setTimeout(this.getStatus, 0)
            }, 3000)
          }
          // 当返回的新值为成功的时候,关闭定时器,结束轮询
          if (newval == 'success') {
            clearInterval(timer)
          }
          // 当页面关闭的时候,结束轮询,否则就会一直发请求,
          //使用$once(eventName, eventHandler)一次性监听事件
          this.$once('hook:boforeDestory', () => {
            clearInterval(timer)
          })
        }
      },
      methods: {
        start:function(){
          showLoading();
          this.timer = setTimeout(this.getStatus, 3000)
        },

        startThread:function(){
          this.$message.warning("开始同步数据......")
          this.timer = setTimeout(this.getStatus, 3000)
          let param={
            nick:'黑泽明君',
            subnick:'',
            funName:'GetTrades',
            status:"1",
          }
          $api.post("/trade/start", param, response => {
            let dataResult = response.data;
            if (dataResult.data == "success") {

              this.timer = setTimeout(this.getStatus, 3000)


            }
          })
        },

        getStatus:function () {
          let param={
            nick:'黑泽明君',
            subnick:'',
            funName:'GetTrades',
            status:"1",
          }
          $api.post("/trade/getStatus", param, response =>{
            let dataResult =  response.data;
            if(dataResult.data == "success") {
              clearTimeout(this.timer);
            }
            else {
              this.timer = setTimeout(this.getStatus, 3000)
            }
            this.$message.warning("数据获取中.....");
          })
        }
      },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/custom/Custom.vue